import * as React from "react";
import { ScaleContinuousNumeric, ScaleTime } from "d3-scale";

export enum AxisType
{
    Top = 1,
    Right = 2,
    Bottom = 3,
    Left = 4
}

type Numeric = number | { valueOf(): number };
interface Props extends React.SVGAttributes<SVGElement>
{
    axisType: AxisType;
    axisScale: ScaleContinuousNumeric<number, number> | ScaleTime<number, number>;
    title?: string;
    
    tickSize?: number;
    tickSizeOuter?: number;
    tickSizeInner?: number;
    tickPadding?: number;
    tickFormat?: (domainValue: number, index: number) => string;
}

const epsilon = 1e-6;

export class Axis extends React.Component<Props, any>
{
    public static defaultProps: Partial<Props> = {
        tickSizeOuter: 6,
        tickSizeInner: 6,
        tickPadding: 3,        
    };

    render()
    {
        let {
            axisType, axisScale,
            tickSizeInner, tickSizeOuter, tickSize, tickPadding, tickFormat,
            ...gProps
        } = this.props;
        if(typeof tickSize === 'number') {
            tickSizeInner = tickSizeOuter = tickSize;
        }

        const k = (axisType === AxisType.Top || axisType === AxisType.Left) ? -1 : 1;
        const transform = (axisType === AxisType.Top || axisType === AxisType.Bottom) ? translateX : translateY;

        const range = axisScale.range();
        const range0 = range[0] + 0.5;
        const range1 = range[range.length - 1] + 0.5;
        const d = (axisType === AxisType.Left || axisType === AxisType.Right)
            ? `M${k * tickSizeOuter},${range0}H0.5V${range1}H${k * tickSizeOuter}`
            : `M${range0},${k * tickSizeOuter}V0.5H${range1}V${k * tickSizeOuter}`;

        const spacing = Math.max(tickSizeInner, 0) + tickPadding;
        const values = axisScale.ticks() as Numeric[];
        const format = tickFormat ? tickFormat : axisScale.tickFormat();

        const lineXY2 = {
            [axisType === AxisType.Left || axisType === AxisType.Right ? 'x2' : 'y2']: k * tickSizeInner 
        };
        const textXY = {
            [axisType === AxisType.Left || axisType === AxisType.Right ? 'x' : 'y']: k * spacing 
        };

        const textAnchor = (axisType === AxisType.Right ? "start" : (axisType === AxisType.Left ? "end" : "middle"));

        return (
            <g fill="none" fontSize="10" fontFamily="sans-serif" textAnchor={textAnchor} {...gProps}>
                <path className="domain" stroke="#000" d={d}/>
                { values.map((d: number | Date, idx: number) => (
                    <g key={idx} transform={transform((axisScale as any)(d))} className="tick">
                        <line {...lineXY2} stroke="#000" />
                        <text fill="#000" {...textXY} dy={axisType === AxisType.Top ? '0em' : axisType === AxisType.Bottom ? '0.71em' : '0.32em' }>{(format as any)(d, idx)}</text>
                    </g>
                )) }
                { this.props.title && <text fill="#000" textAnchor="end" y={6} dy="0.71em" transform="rotate(-90)" >{this.props.title}</text>}
            </g>
        );
    }
}

function translateX(x: number)
{
    return `translate(${x}, 0)`;
}

function translateY(y: number)
{
    return `translate(0, ${y})`;
}


// WEBPACK FOOTER //
// ./src/d3chart/Axes.tsx